export function formatPersianNumber(num) {
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return num
    ?.toString()
    ?.replace(/\d/g, (digit) => persianDigits?.[digit])
    .toLocaleString('fa-IR');
}
